



import { Component as NodeComponent } from 'vue'
import { Vue, Component } from 'vue-property-decorator'
import InputPage from './components/inputPage.vue'
import OutputPage from './components/outputPage.vue'
@Component({
  components: {
    InputPage,
    OutputPage
  }
})
export default class extends Vue {
    page: NodeComponent = InputPage
    private handleClick (type: string) {
      console.log(type)
      switch (type) {
        case 'output':
          this.page = OutputPage
          break
        case 'input':
        default:
          this.page = InputPage
          break
      }
    }
}
